import React from "react";
import useSmartviewManager from "../hooks/use-smartview-manager";
import WhenCanGoBack from "../conditionals/WhenCanGoBack";

export default function SmartviewBackTrigger(props) {

    const smartviewManager = useSmartviewManager();

    return (
        <WhenCanGoBack>
            {React.Children.map(props.children, child => (
                React.cloneElement(child, {onClick: () => smartviewManager.back()})
            ))}
        </WhenCanGoBack>
    );
}
